export function isArray(a) {
  return Array.isArray(a)
}

export function same(a, b) {
  if (!isArray(a) || !isArray(b)) throw new Error(`Arrays expected, got ${typeof a} and ${typeof b}`)
  return a.length === b.length && a.every(el => {
    return b.includes(el)
  })
}

export function* toChunks(arr, n = 4) {
  for (let i = 0; i < arr.length; i += n) {
    yield arr.slice(i, i + n)
  }
}

export function hasAtLeast(arr, predicate, limit = arr.length) {
  let count = 0
  for (const item of arr) {
    if (predicate(item)) {
      count++
      if (count >= limit) break
    }
  }
  return count
}

export function getRandom(arr, count = 3) {
  const result = []
  const used = new Set()

  while (result.length < count && used.size < arr.length) {
    const index = Math.floor(Math.random() * arr.length)
    if (!used.has(index)) {
      used.add(index)
      result.push(arr[index])
    }
  }

  return result
}

export function serialize(set) {
  return JSON.stringify([...set].sort())
}

export function getVisible(items, max = 4) {
  if (items.length <= max) {
    return {
      visible: items,
      rest: []
    }
  }

  const visible_count = max - 1

  return {
    visible: items.slice(0, visible_count),
    rest: items.slice(visible_count)
  }
}